import { render } from "./iconDollar.vue?vue&type=template&id=0945000e"
import script from "./iconDollar.vue?vue&type=script&lang=js"
export * from "./iconDollar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__